import { ChangeDetectorRef, Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from './core/services/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor(translate: TranslateService,
              public spinnerService: SpinnerService,
              private changeDetectorRef: ChangeDetectorRef,
              private matIconRegistry:MatIconRegistry,
              private domSanitizer: DomSanitizer) {
    // this language will be used as a fallback when a translation isn't found in the current language
  //  translate.setDefaultLang('ar');

    let browserLang = translate.getBrowserLang();
    // add custom icons
    this.matIconRegistry.addSvgIcon("main_menu_settings",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/settings.svg"));
    this.matIconRegistry.addSvgIcon("main_menu_calendar",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/calendar.svg"));
    this.matIconRegistry.addSvgIcon("main_menu_users_management",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/users-management.svg"));
    this.matIconRegistry.addSvgIcon("main_menu_group_management",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/group-management.svg"));
    this.matIconRegistry.addSvgIcon('success-hat',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/success_hat.svg'));
    this.matIconRegistry.addSvgIcon('star',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/star.svg'));
    this.matIconRegistry.addSvgIcon('lower-image-decoration',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/lower-image-decoration.svg'));
    this.matIconRegistry.addSvgIcon('upper-image-decoration',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/upper-image-decoration.svg'));
    this.matIconRegistry.addSvgIcon('user-view',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/view.svg'));
    this.matIconRegistry.addSvgIcon('user-edit',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/edit.svg'));
    this.matIconRegistry.addSvgIcon('user-delete',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/delete.svg'));
    this.matIconRegistry.addSvgIcon('user-function',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/function.svg'));
    this.matIconRegistry.addSvgIcon('elipse',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/ellipse.svg'));
    this.matIconRegistry.addSvgIcon('line',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/line.svg'));
    this.matIconRegistry.addSvgIcon('done',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/done.svg'));
    this.matIconRegistry.addSvgIcon('history',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/history1.svg'));  
    this.matIconRegistry.addSvgIcon('key-login',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/key.svg'));   
    this.matIconRegistry.addSvgIcon('user-login',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/user.svg'));  
    this.matIconRegistry.addSvgIcon('user-menu',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/users-menu.svg'));   
    this.matIconRegistry.addSvgIcon('learner-menu',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/learners-menu.svg'));  
    this.matIconRegistry.addSvgIcon('group-menu',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/groups-menu.svg'));   
    this.matIconRegistry.addSvgIcon('setting-menu',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/settings-menu.svg'));
    this.matIconRegistry.addSvgIcon('calendar-menu',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/calendar-menu.svg'));
    this.matIconRegistry.addSvgIcon('score',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/scores.svg'));
    //  translate.use(browserLang.match(/en|fr|ar/) ? browserLang : 'ar');
  }

  ngAfterContentChecked() : void {
    this.changeDetectorRef.detectChanges();
  }

}
